import { InjectionToken } from '@angular/core';

/** Signalr config Injection Token */
export const SIGNAL_R_API_URL_TOKEN: InjectionToken<string> = new InjectionToken(
  'SIGNAL_R_API_URL_TOKEN',
);
